import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    // Nav
    app_name: "Labelled",
    find_community: "Find your community",
    search_placeholder: "Search postcode, city, or address...",
    filter: "Filter",
    info: "Info",
    host: "Host",
    admin: "Admin",
    // Welcome panel
    connect_text: "Connect with neurodivergent people in your area. Add your pin to join the map!",
    add_my_pin: "Add My Pin",
    manage_pins: "Manage My Pins",
    add_event: "Add Community Event",
    // Pin form
    edit_pin: "Edit Your Pin",
    add_pin: "Add Your Pin",
    find_area: "Find your area",
    use_location: "Use my current location",
    search_postcode: "Or search postcode/city...",
    click_map: "Or click on the map",
    no_location: "No location selected yet",
    select_labels: "Select your labels",
    finding_location: "Finding location...",
    update_pin: "Update Pin",
    saving: "Saving...",
    remove_instead: "Remove Pin Instead",
    // Filter
    filter_by_label: "Filter by Label",
    clear_filters: "Clear Filters",
    // Info panel
    info_legend: "Info & Legend",
    privacy_protected: "Privacy Protected",
    privacy_text: "Exact locations are NEVER shown. We only display town/area counts with a random offset. No houses or streets are visible.",
    label_colors: "Label Colors",
    how_it_works: "How It Works",
    numbers_show: "Numbers show people in each area",
    colors_indicate: "Colors indicate the community mix",
    green_badge: "Green badge = local events available",
    click_area: "Click an area to see details",
    // Area detail
    community_members: "community members",
    breakdown: "Breakdown",
    local_events: "Local Events",
    share_area: "Share This Area",
    // Events
    community_event: "Add Community Event",
    free_listing: "Free Listing",
    basic_visibility: "Basic visibility",
    featured: "Featured",
    top_placement: "Top placement",
    featured_price: "Featured Event - £5/month",
    feat_highlight: "Highlighted at top of area listings",
    feat_badge: "Special badge on map markers",
    feat_priority: "Priority in search results",
    feat_analytics: "Analytics dashboard access",
    feat_redirect: "You'll be redirected to create a host account",
    event_title: "Event Title",
    description: "Description",
    town_city: "Town/City",
    country: "Country",
    event_type: "Event Type",
    contact_info: "Contact Info",
    recurring_event: "Recurring event",
    schedule: "Schedule",
    submit_event: "Submit Event",
    continue_payment: "Continue to Payment",
    submitting: "Submitting...",
    meetup: "Meetup",
    support_group: "Support Group",
    workshop: "Workshop",
    social_event: "Social Event",
    // My pins
    my_pins: "My Pins",
    move_edit: "Move/Edit",
    remove: "Remove",
    // Stats
    people: "people",
    areas: "areas",
    // Calendar
    calendar: "Calendar",
    event_calendar: "Event Calendar",
    no_events_date: "No events on this date",
    all_events: "All Events",
    // General
    search: "Search",
    close: "Close",
    cancel: "Cancel",
    back_to_map: "Back to Map",
    people_in_area: "people in this area",
    community_breakdown: "Community Breakdown",
    // Language
    language: "Language",
  },
  zh: {
    app_name: "Labelled",
    find_community: "找到你的社区",
    search_placeholder: "搜索邮编、城市或地址...",
    filter: "筛选",
    info: "信息",
    host: "主办",
    admin: "管理",
    connect_text: "与您所在地区的神经多样性人群建立联系。添加您的图钉加入地图！",
    add_my_pin: "添加我的图钉",
    manage_pins: "管理我的图钉",
    add_event: "添加社区活动",
    edit_pin: "编辑您的图钉",
    add_pin: "添加您的图钉",
    find_area: "查找您的区域",
    use_location: "使用我的当前位置",
    search_postcode: "或搜索邮编/城市...",
    click_map: "或点击地图",
    no_location: "尚未选择位置",
    select_labels: "选择您的标签",
    finding_location: "正在查找位置...",
    update_pin: "更新图钉",
    saving: "保存中...",
    remove_instead: "改为删除图钉",
    filter_by_label: "按标签筛选",
    clear_filters: "清除筛选",
    info_legend: "信息和图例",
    privacy_protected: "隐私受保护",
    privacy_text: "确切位置永远不会显示。我们只显示城镇/地区计数和随机偏移。",
    label_colors: "标签颜色",
    how_it_works: "使用方法",
    numbers_show: "数字显示每个区域的人数",
    colors_indicate: "颜色表示社区组成",
    green_badge: "绿色标志 = 有当地活动",
    click_area: "点击区域查看详情",
    community_members: "社区成员",
    breakdown: "详细分布",
    local_events: "当地活动",
    share_area: "分享此区域",
    community_event: "添加社区活动",
    free_listing: "免费列表",
    basic_visibility: "基本可见性",
    featured: "推荐",
    top_placement: "置顶显示",
    featured_price: "推荐活动 - £5/月",
    feat_highlight: "在区域列表顶部突出显示",
    feat_badge: "地图标记上的特殊标志",
    feat_priority: "搜索结果优先",
    feat_analytics: "分析仪表板访问权限",
    feat_redirect: "您将被重定向以创建主办账户",
    event_title: "活动标题",
    description: "描述",
    town_city: "城镇/城市",
    country: "国家",
    event_type: "活动类型",
    contact_info: "联系方式",
    recurring_event: "定期活动",
    schedule: "时间表",
    submit_event: "提交活动",
    continue_payment: "继续支付",
    submitting: "提交中...",
    meetup: "聚会",
    support_group: "互助小组",
    workshop: "工作坊",
    social_event: "社交活动",
    my_pins: "我的图钉",
    move_edit: "移动/编辑",
    remove: "删除",
    people: "人",
    areas: "区域",
    calendar: "日历",
    event_calendar: "活动日历",
    no_events_date: "该日期无活动",
    all_events: "所有活动",
    search: "搜索",
    close: "关闭",
    cancel: "取消",
    back_to_map: "返回地图",
    people_in_area: "该区域的人数",
    community_breakdown: "社区分布",
    language: "语言",
  },
  es: {
    app_name: "Labelled",
    find_community: "Encuentra tu comunidad",
    search_placeholder: "Buscar código postal, ciudad o dirección...",
    filter: "Filtrar",
    info: "Info",
    host: "Anfitrión",
    admin: "Admin",
    connect_text: "Conéctate con personas neurodivergentes en tu área. ¡Añade tu pin al mapa!",
    add_my_pin: "Añadir Mi Pin",
    manage_pins: "Gestionar Mis Pins",
    add_event: "Añadir Evento",
    edit_pin: "Editar Tu Pin",
    add_pin: "Añadir Tu Pin",
    find_area: "Encuentra tu zona",
    use_location: "Usar mi ubicación actual",
    search_postcode: "O buscar código postal/ciudad...",
    click_map: "O haz clic en el mapa",
    no_location: "Ninguna ubicación seleccionada",
    select_labels: "Selecciona tus etiquetas",
    finding_location: "Buscando ubicación...",
    update_pin: "Actualizar Pin",
    saving: "Guardando...",
    remove_instead: "Eliminar Pin",
    filter_by_label: "Filtrar por Etiqueta",
    clear_filters: "Limpiar Filtros",
    info_legend: "Info y Leyenda",
    privacy_protected: "Privacidad Protegida",
    privacy_text: "Las ubicaciones exactas NUNCA se muestran. Solo mostramos conteos por área.",
    label_colors: "Colores de Etiquetas",
    how_it_works: "Cómo Funciona",
    numbers_show: "Los números muestran personas en cada área",
    colors_indicate: "Los colores indican la mezcla comunitaria",
    green_badge: "Insignia verde = eventos locales disponibles",
    click_area: "Haz clic en un área para ver detalles",
    community_members: "miembros de la comunidad",
    breakdown: "Desglose",
    local_events: "Eventos Locales",
    share_area: "Compartir Área",
    community_event: "Añadir Evento Comunitario",
    free_listing: "Listado Gratuito",
    basic_visibility: "Visibilidad básica",
    featured: "Destacado",
    top_placement: "Posición superior",
    featured_price: "Evento Destacado - £5/mes",
    feat_highlight: "Destacado en la parte superior",
    feat_badge: "Insignia especial en marcadores",
    feat_priority: "Prioridad en búsquedas",
    feat_analytics: "Acceso al panel de análisis",
    feat_redirect: "Serás redirigido para crear una cuenta",
    event_title: "Título del Evento",
    description: "Descripción",
    town_city: "Ciudad/Pueblo",
    country: "País",
    event_type: "Tipo de Evento",
    contact_info: "Contacto",
    recurring_event: "Evento recurrente",
    schedule: "Horario",
    submit_event: "Enviar Evento",
    continue_payment: "Continuar al Pago",
    submitting: "Enviando...",
    meetup: "Encuentro",
    support_group: "Grupo de Apoyo",
    workshop: "Taller",
    social_event: "Evento Social",
    my_pins: "Mis Pins",
    move_edit: "Mover/Editar",
    remove: "Eliminar",
    people: "personas",
    areas: "áreas",
    calendar: "Calendario",
    event_calendar: "Calendario de Eventos",
    no_events_date: "Sin eventos en esta fecha",
    all_events: "Todos los Eventos",
    search: "Buscar",
    close: "Cerrar",
    cancel: "Cancelar",
    back_to_map: "Volver al Mapa",
    people_in_area: "personas en esta área",
    community_breakdown: "Composición de la Comunidad",
    language: "Idioma",
  },
  fr: {
    app_name: "Labelled",
    find_community: "Trouvez votre communauté",
    search_placeholder: "Rechercher code postal, ville ou adresse...",
    filter: "Filtrer",
    info: "Info",
    host: "Hôte",
    admin: "Admin",
    connect_text: "Connectez-vous avec des personnes neurodivergentes dans votre région. Ajoutez votre épingle !",
    add_my_pin: "Ajouter Mon Épingle",
    manage_pins: "Gérer Mes Épingles",
    add_event: "Ajouter un Événement",
    edit_pin: "Modifier Votre Épingle",
    add_pin: "Ajouter Votre Épingle",
    find_area: "Trouvez votre zone",
    use_location: "Utiliser ma position actuelle",
    search_postcode: "Ou chercher code postal/ville...",
    click_map: "Ou cliquez sur la carte",
    no_location: "Aucun emplacement sélectionné",
    select_labels: "Sélectionnez vos étiquettes",
    finding_location: "Recherche de la position...",
    update_pin: "Mettre à Jour",
    saving: "Enregistrement...",
    remove_instead: "Supprimer l'Épingle",
    filter_by_label: "Filtrer par Étiquette",
    clear_filters: "Effacer les Filtres",
    info_legend: "Info et Légende",
    privacy_protected: "Vie Privée Protégée",
    privacy_text: "Les emplacements exacts ne sont JAMAIS affichés. Nous n'affichons que les comptages par zone.",
    label_colors: "Couleurs des Étiquettes",
    how_it_works: "Comment ça Marche",
    numbers_show: "Les chiffres montrent les personnes dans chaque zone",
    colors_indicate: "Les couleurs indiquent la composition",
    green_badge: "Badge vert = événements locaux disponibles",
    click_area: "Cliquez sur une zone pour les détails",
    community_members: "membres de la communauté",
    breakdown: "Répartition",
    local_events: "Événements Locaux",
    share_area: "Partager cette Zone",
    community_event: "Ajouter un Événement",
    free_listing: "Gratuit",
    basic_visibility: "Visibilité basique",
    featured: "En Vedette",
    top_placement: "Placement prioritaire",
    featured_price: "Événement en Vedette - 5£/mois",
    feat_highlight: "Mis en avant en haut des listes",
    feat_badge: "Badge spécial sur les marqueurs",
    feat_priority: "Priorité dans les recherches",
    feat_analytics: "Accès au tableau de bord",
    feat_redirect: "Vous serez redirigé pour créer un compte",
    event_title: "Titre de l'Événement",
    description: "Description",
    town_city: "Ville",
    country: "Pays",
    event_type: "Type d'Événement",
    contact_info: "Contact",
    recurring_event: "Événement récurrent",
    schedule: "Horaire",
    submit_event: "Soumettre",
    continue_payment: "Continuer vers le Paiement",
    submitting: "Envoi en cours...",
    meetup: "Rencontre",
    support_group: "Groupe de Soutien",
    workshop: "Atelier",
    social_event: "Événement Social",
    my_pins: "Mes Épingles",
    move_edit: "Déplacer/Modifier",
    remove: "Supprimer",
    people: "personnes",
    areas: "zones",
    calendar: "Calendrier",
    event_calendar: "Calendrier des Événements",
    no_events_date: "Aucun événement à cette date",
    all_events: "Tous les Événements",
    search: "Rechercher",
    close: "Fermer",
    cancel: "Annuler",
    back_to_map: "Retour à la Carte",
    people_in_area: "personnes dans cette zone",
    community_breakdown: "Composition de la Communauté",
    language: "Langue",
  },
  sw: {
    app_name: "Labelled",
    find_community: "Pata jamii yako",
    search_placeholder: "Tafuta msimbo wa posta, jiji...",
    filter: "Chuja",
    info: "Habari",
    host: "Mwenyeji",
    admin: "Msimamizi",
    connect_text: "Ungana na watu wenye neurodivergent katika eneo lako. Ongeza pini yako!",
    add_my_pin: "Ongeza Pini Yangu",
    manage_pins: "Simamia Pini Zangu",
    add_event: "Ongeza Tukio",
    edit_pin: "Hariri Pini",
    add_pin: "Ongeza Pini",
    find_area: "Pata eneo lako",
    use_location: "Tumia eneo langu la sasa",
    search_postcode: "Au tafuta msimbo/jiji...",
    click_map: "Au bofya ramani",
    no_location: "Hakuna eneo lililochaguliwa",
    select_labels: "Chagua lebo zako",
    finding_location: "Inatafuta eneo...",
    update_pin: "Sasisha",
    saving: "Inahifadhi...",
    remove_instead: "Ondoa Pini",
    filter_by_label: "Chuja kwa Lebo",
    clear_filters: "Futa Vichujio",
    info_legend: "Habari na Ufunguo",
    privacy_protected: "Faragha Inalindwa",
    privacy_text: "Maeneo halisi HAYAONYESHWI kamwe. Tunaonyesha tu hesabu za eneo.",
    label_colors: "Rangi za Lebo",
    how_it_works: "Jinsi Inavyofanya Kazi",
    numbers_show: "Nambari zinaonyesha watu katika kila eneo",
    colors_indicate: "Rangi zinaonyesha mchanganyiko",
    green_badge: "Beji ya kijani = matukio ya ndani",
    click_area: "Bofya eneo kwa maelezo",
    community_members: "wanajamii",
    breakdown: "Mgawanyo",
    local_events: "Matukio ya Ndani",
    share_area: "Shiriki Eneo",
    community_event: "Ongeza Tukio",
    free_listing: "Bure",
    basic_visibility: "Mwonekano wa msingi",
    featured: "Iliyoangaziwa",
    top_placement: "Nafasi ya juu",
    featured_price: "Tukio Maalum - £5/mwezi",
    feat_highlight: "Imeangaziwa juu ya orodha",
    feat_badge: "Beji maalum kwenye ramani",
    feat_priority: "Kipaumbele katika utafutaji",
    feat_analytics: "Ufikiaji wa dashibodi",
    feat_redirect: "Utaelekezwa kuunda akaunti",
    event_title: "Kichwa cha Tukio",
    description: "Maelezo",
    town_city: "Mji",
    country: "Nchi",
    event_type: "Aina ya Tukio",
    contact_info: "Mawasiliano",
    recurring_event: "Tukio la kurudia",
    schedule: "Ratiba",
    submit_event: "Wasilisha",
    continue_payment: "Endelea na Malipo",
    submitting: "Inawasilisha...",
    meetup: "Mkutano",
    support_group: "Kundi la Msaada",
    workshop: "Warsha",
    social_event: "Tukio la Kijamii",
    my_pins: "Pini Zangu",
    move_edit: "Hamisha/Hariri",
    remove: "Ondoa",
    people: "watu",
    areas: "maeneo",
    calendar: "Kalenda",
    event_calendar: "Kalenda ya Matukio",
    no_events_date: "Hakuna matukio tarehe hii",
    all_events: "Matukio Yote",
    search: "Tafuta",
    close: "Funga",
    cancel: "Ghairi",
    back_to_map: "Rudi kwenye Ramani",
    people_in_area: "watu katika eneo hili",
    community_breakdown: "Mgawanyo wa Jamii",
    language: "Lugha",
  },
  ar: {
    app_name: "Labelled",
    find_community: "ابحث عن مجتمعك",
    search_placeholder: "البحث عن الرمز البريدي أو المدينة...",
    filter: "تصفية",
    info: "معلومات",
    host: "مضيف",
    admin: "مشرف",
    connect_text: "تواصل مع أشخاص من ذوي التنوع العصبي في منطقتك. أضف دبوسك!",
    add_my_pin: "أضف دبوسي",
    manage_pins: "إدارة دبابيسي",
    add_event: "إضافة حدث",
    edit_pin: "تعديل الدبوس",
    add_pin: "إضافة الدبوس",
    find_area: "ابحث عن منطقتك",
    use_location: "استخدم موقعي الحالي",
    search_postcode: "أو ابحث عن الرمز البريدي...",
    click_map: "أو انقر على الخريطة",
    no_location: "لم يتم تحديد موقع",
    select_labels: "اختر تصنيفاتك",
    finding_location: "جاري البحث عن الموقع...",
    update_pin: "تحديث",
    saving: "جاري الحفظ...",
    remove_instead: "إزالة الدبوس",
    filter_by_label: "تصفية حسب التصنيف",
    clear_filters: "مسح التصفية",
    info_legend: "معلومات ودليل",
    privacy_protected: "الخصوصية محمية",
    privacy_text: "لا تُعرض المواقع الدقيقة أبداً. نعرض فقط إحصائيات المنطقة.",
    label_colors: "ألوان التصنيفات",
    how_it_works: "كيف يعمل",
    numbers_show: "الأرقام تظهر الأشخاص في كل منطقة",
    colors_indicate: "الألوان تشير إلى التكوين المجتمعي",
    green_badge: "شارة خضراء = أحداث محلية متاحة",
    click_area: "انقر على منطقة للتفاصيل",
    community_members: "أعضاء المجتمع",
    breakdown: "التفصيل",
    local_events: "الأحداث المحلية",
    share_area: "مشاركة المنطقة",
    community_event: "إضافة حدث مجتمعي",
    free_listing: "مجاني",
    basic_visibility: "رؤية أساسية",
    featured: "مميز",
    top_placement: "مكان بارز",
    featured_price: "حدث مميز - £5/شهر",
    feat_highlight: "مميز في أعلى القوائم",
    feat_badge: "شارة خاصة على الخريطة",
    feat_priority: "أولوية في البحث",
    feat_analytics: "لوحة تحليلات",
    feat_redirect: "ستتم إعادة توجيهك لإنشاء حساب",
    event_title: "عنوان الحدث",
    description: "الوصف",
    town_city: "المدينة",
    country: "البلد",
    event_type: "نوع الحدث",
    contact_info: "معلومات الاتصال",
    recurring_event: "حدث متكرر",
    schedule: "الجدول",
    submit_event: "إرسال",
    continue_payment: "متابعة الدفع",
    submitting: "جاري الإرسال...",
    meetup: "لقاء",
    support_group: "مجموعة دعم",
    workshop: "ورشة عمل",
    social_event: "حدث اجتماعي",
    my_pins: "دبابيسي",
    move_edit: "نقل/تعديل",
    remove: "إزالة",
    people: "أشخاص",
    areas: "مناطق",
    calendar: "التقويم",
    event_calendar: "تقويم الأحداث",
    no_events_date: "لا أحداث في هذا التاريخ",
    all_events: "جميع الأحداث",
    search: "بحث",
    close: "إغلاق",
    cancel: "إلغاء",
    back_to_map: "العودة إلى الخريطة",
    people_in_area: "أشخاص في هذه المنطقة",
    community_breakdown: "تركيبة المجتمع",
    language: "اللغة",
  },
  hi: {
    app_name: "Labelled",
    find_community: "अपना समुदाय खोजें",
    search_placeholder: "पिनकोड, शहर या पता खोजें...",
    filter: "फ़िल्टर",
    info: "जानकारी",
    host: "होस्ट",
    admin: "व्यवस्थापक",
    connect_text: "अपने क्षेत्र में न्यूरोडाइवर्जेंट लोगों से जुड़ें। अपना पिन जोड़ें!",
    add_my_pin: "मेरा पिन जोड़ें",
    manage_pins: "मेरे पिन प्रबंधित करें",
    add_event: "इवेंट जोड़ें",
    edit_pin: "पिन संपादित करें",
    add_pin: "पिन जोड़ें",
    find_area: "अपना क्षेत्र खोजें",
    use_location: "मेरा वर्तमान स्थान उपयोग करें",
    search_postcode: "या पिनकोड/शहर खोजें...",
    click_map: "या मानचित्र पर क्लिक करें",
    no_location: "कोई स्थान चयनित नहीं",
    select_labels: "अपने लेबल चुनें",
    finding_location: "स्थान खोज रहे हैं...",
    update_pin: "अपडेट करें",
    saving: "सहेज रहे हैं...",
    remove_instead: "पिन हटाएं",
    filter_by_label: "लेबल से फ़िल्टर करें",
    clear_filters: "फ़िल्टर साफ़ करें",
    info_legend: "जानकारी और लीजेंड",
    privacy_protected: "गोपनीयता सुरक्षित",
    privacy_text: "सटीक स्थान कभी नहीं दिखाए जाते। हम केवल क्षेत्र की गणना दिखाते हैं।",
    label_colors: "लेबल रंग",
    how_it_works: "यह कैसे काम करता है",
    numbers_show: "संख्या प्रत्येक क्षेत्र में लोगों को दर्शाती है",
    colors_indicate: "रंग समुदाय मिश्रण को दर्शाते हैं",
    green_badge: "हरा बैज = स्थानीय कार्यक्रम उपलब्ध",
    click_area: "विवरण के लिए क्षेत्र पर क्लिक करें",
    community_members: "समुदाय सदस्य",
    breakdown: "विवरण",
    local_events: "स्थानीय कार्यक्रम",
    share_area: "क्षेत्र साझा करें",
    community_event: "सामुदायिक कार्यक्रम जोड़ें",
    free_listing: "मुफ़्त",
    basic_visibility: "बुनियादी दृश्यता",
    featured: "विशेष",
    top_placement: "शीर्ष स्थान",
    featured_price: "विशेष इवेंट - £5/माह",
    feat_highlight: "सूची में शीर्ष पर हाइलाइट",
    feat_badge: "मार्कर पर विशेष बैज",
    feat_priority: "खोज में प्राथमिकता",
    feat_analytics: "एनालिटिक्स डैशबोर्ड",
    feat_redirect: "आपको खाता बनाने के लिए रीडायरेक्ट किया जाएगा",
    event_title: "इवेंट शीर्षक",
    description: "विवरण",
    town_city: "शहर",
    country: "देश",
    event_type: "इवेंट प्रकार",
    contact_info: "संपर्क जानकारी",
    recurring_event: "आवर्ती कार्यक्रम",
    schedule: "अनुसूची",
    submit_event: "जमा करें",
    continue_payment: "भुगतान जारी रखें",
    submitting: "जमा हो रहा है...",
    meetup: "मिलन",
    support_group: "सहायता समूह",
    workshop: "कार्यशाला",
    social_event: "सामाजिक कार्यक्रम",
    my_pins: "मेरे पिन",
    move_edit: "स्थानांतरित/संपादित",
    remove: "हटाएं",
    people: "लोग",
    areas: "क्षेत्र",
    calendar: "कैलेंडर",
    event_calendar: "इवेंट कैलेंडर",
    no_events_date: "इस तारीख पर कोई इवेंट नहीं",
    all_events: "सभी इवेंट",
    search: "खोजें",
    close: "बंद करें",
    cancel: "रद्द करें",
    back_to_map: "मानचित्र पर वापस",
    people_in_area: "इस क्षेत्र में लोग",
    community_breakdown: "समुदाय संरचना",
    language: "भाषा",
  },
  vi: {
    app_name: "Labelled",
    find_community: "Tìm cộng đồng của bạn",
    search_placeholder: "Tìm mã bưu điện, thành phố...",
    filter: "Lọc",
    info: "Thông tin",
    host: "Chủ tổ chức",
    admin: "Quản trị",
    connect_text: "Kết nối với người đa dạng thần kinh trong khu vực của bạn. Thêm ghim của bạn!",
    add_my_pin: "Thêm Ghim",
    manage_pins: "Quản Lý Ghim",
    add_event: "Thêm Sự Kiện",
    edit_pin: "Sửa Ghim",
    add_pin: "Thêm Ghim",
    find_area: "Tìm khu vực",
    use_location: "Dùng vị trí hiện tại",
    search_postcode: "Hoặc tìm mã bưu điện...",
    click_map: "Hoặc nhấn vào bản đồ",
    no_location: "Chưa chọn vị trí",
    select_labels: "Chọn nhãn",
    finding_location: "Đang tìm vị trí...",
    update_pin: "Cập nhật",
    saving: "Đang lưu...",
    remove_instead: "Xóa Ghim",
    filter_by_label: "Lọc theo Nhãn",
    clear_filters: "Xóa Bộ Lọc",
    info_legend: "Thông tin & Chú giải",
    privacy_protected: "Quyền riêng tư được bảo vệ",
    privacy_text: "Vị trí chính xác KHÔNG BAO GIỜ được hiển thị.",
    label_colors: "Màu Nhãn",
    how_it_works: "Cách hoạt động",
    numbers_show: "Số hiển thị người trong mỗi khu vực",
    colors_indicate: "Màu sắc cho thấy thành phần cộng đồng",
    green_badge: "Huy hiệu xanh = có sự kiện địa phương",
    click_area: "Nhấp vào khu vực để xem chi tiết",
    community_members: "thành viên cộng đồng",
    breakdown: "Chi tiết",
    local_events: "Sự Kiện Địa Phương",
    share_area: "Chia Sẻ Khu Vực",
    community_event: "Thêm Sự Kiện",
    free_listing: "Miễn phí",
    basic_visibility: "Hiển thị cơ bản",
    featured: "Nổi bật",
    top_placement: "Vị trí hàng đầu",
    featured_price: "Sự kiện nổi bật - £5/tháng",
    feat_highlight: "Nổi bật ở đầu danh sách",
    feat_badge: "Huy hiệu đặc biệt trên bản đồ",
    feat_priority: "Ưu tiên trong tìm kiếm",
    feat_analytics: "Bảng phân tích",
    feat_redirect: "Bạn sẽ được chuyển hướng để tạo tài khoản",
    event_title: "Tên Sự Kiện",
    description: "Mô tả",
    town_city: "Thành phố",
    country: "Quốc gia",
    event_type: "Loại Sự Kiện",
    contact_info: "Liên hệ",
    recurring_event: "Sự kiện định kỳ",
    schedule: "Lịch trình",
    submit_event: "Gửi",
    continue_payment: "Tiếp tục Thanh toán",
    submitting: "Đang gửi...",
    meetup: "Gặp mặt",
    support_group: "Nhóm hỗ trợ",
    workshop: "Hội thảo",
    social_event: "Sự kiện xã hội",
    my_pins: "Ghim Của Tôi",
    move_edit: "Di chuyển/Sửa",
    remove: "Xóa",
    people: "người",
    areas: "khu vực",
    calendar: "Lịch",
    event_calendar: "Lịch Sự Kiện",
    no_events_date: "Không có sự kiện vào ngày này",
    all_events: "Tất Cả Sự Kiện",
    search: "Tìm kiếm",
    close: "Đóng",
    cancel: "Hủy",
    back_to_map: "Về Bản Đồ",
    people_in_area: "người trong khu vực này",
    community_breakdown: "Thành phần Cộng đồng",
    language: "Ngôn ngữ",
  },
  ru: {
    app_name: "Labelled",
    find_community: "Найдите свое сообщество",
    search_placeholder: "Поиск по индексу, городу или адресу...",
    filter: "Фильтр",
    info: "Инфо",
    host: "Организатор",
    admin: "Админ",
    connect_text: "Свяжитесь с нейроотличными людьми в вашем районе. Добавьте свою метку!",
    add_my_pin: "Добавить Метку",
    manage_pins: "Мои Метки",
    add_event: "Добавить Событие",
    edit_pin: "Редактировать Метку",
    add_pin: "Добавить Метку",
    find_area: "Найдите свой район",
    use_location: "Использовать моё местоположение",
    search_postcode: "Или найти индекс/город...",
    click_map: "Или нажмите на карту",
    no_location: "Местоположение не выбрано",
    select_labels: "Выберите ярлыки",
    finding_location: "Поиск местоположения...",
    update_pin: "Обновить",
    saving: "Сохранение...",
    remove_instead: "Удалить Метку",
    filter_by_label: "Фильтр по Ярлыку",
    clear_filters: "Сбросить Фильтры",
    info_legend: "Информация и Легенда",
    privacy_protected: "Конфиденциальность Защищена",
    privacy_text: "Точные местоположения НИКОГДА не показываются.",
    label_colors: "Цвета Ярлыков",
    how_it_works: "Как это Работает",
    numbers_show: "Числа показывают людей в каждом районе",
    colors_indicate: "Цвета указывают на состав сообщества",
    green_badge: "Зелёный значок = доступны местные события",
    click_area: "Нажмите на район для подробностей",
    community_members: "членов сообщества",
    breakdown: "Разбивка",
    local_events: "Местные События",
    share_area: "Поделиться Районом",
    community_event: "Добавить Событие",
    free_listing: "Бесплатно",
    basic_visibility: "Базовая видимость",
    featured: "Рекомендуемое",
    top_placement: "Верхнее размещение",
    featured_price: "Рекомендуемое - £5/мес",
    feat_highlight: "Выделено вверху списков",
    feat_badge: "Специальный значок на карте",
    feat_priority: "Приоритет в поиске",
    feat_analytics: "Панель аналитики",
    feat_redirect: "Вы будете перенаправлены для создания аккаунта",
    event_title: "Название События",
    description: "Описание",
    town_city: "Город",
    country: "Страна",
    event_type: "Тип События",
    contact_info: "Контакт",
    recurring_event: "Повторяющееся событие",
    schedule: "Расписание",
    submit_event: "Отправить",
    continue_payment: "Перейти к Оплате",
    submitting: "Отправка...",
    meetup: "Встреча",
    support_group: "Группа Поддержки",
    workshop: "Мастер-класс",
    social_event: "Социальное Событие",
    my_pins: "Мои Метки",
    move_edit: "Переместить/Изменить",
    remove: "Удалить",
    people: "людей",
    areas: "районов",
    calendar: "Календарь",
    event_calendar: "Календарь Событий",
    no_events_date: "Нет событий на эту дату",
    all_events: "Все События",
    search: "Поиск",
    close: "Закрыть",
    cancel: "Отмена",
    back_to_map: "На Карту",
    people_in_area: "людей в этом районе",
    community_breakdown: "Состав Сообщества",
    language: "Язык",
  },
  cy: {
    app_name: "Labelled",
    find_community: "Dod o hyd i'ch cymuned",
    search_placeholder: "Chwilio cod post, dinas neu gyfeiriad...",
    filter: "Hidlo",
    info: "Gwybodaeth",
    host: "Cynhaliwr",
    admin: "Gweinyddwr",
    connect_text: "Cysylltwch â phobl niwroamrywiol yn eich ardal. Ychwanegwch eich pin!",
    add_my_pin: "Ychwanegu Pin",
    manage_pins: "Rheoli Pinnau",
    add_event: "Ychwanegu Digwyddiad",
    edit_pin: "Golygu Pin",
    add_pin: "Ychwanegu Pin",
    find_area: "Dod o hyd i'ch ardal",
    use_location: "Defnyddio fy lleoliad",
    search_postcode: "Neu chwilio cod post...",
    click_map: "Neu cliciwch ar y map",
    no_location: "Dim lleoliad wedi'i ddewis",
    select_labels: "Dewiswch eich labeli",
    finding_location: "Chwilio am leoliad...",
    update_pin: "Diweddaru",
    saving: "Cadw...",
    remove_instead: "Dileu Pin",
    filter_by_label: "Hidlo yn ôl Label",
    clear_filters: "Clirio Hidlau",
    info_legend: "Gwybodaeth ac Allwedd",
    privacy_protected: "Preifatrwydd wedi'i Ddiogelu",
    privacy_text: "Ni ddangosir lleoliadau manwl BYTH. Rydym ond yn dangos cyfrifon ardal.",
    label_colors: "Lliwiau Label",
    how_it_works: "Sut Mae'n Gweithio",
    numbers_show: "Mae rhifau yn dangos pobl ym mhob ardal",
    colors_indicate: "Mae lliwiau yn dangos cymysgedd y gymuned",
    green_badge: "Bathodyn gwyrdd = digwyddiadau lleol ar gael",
    click_area: "Cliciwch ardal am fanylion",
    community_members: "aelodau'r gymuned",
    breakdown: "Dadansoddiad",
    local_events: "Digwyddiadau Lleol",
    share_area: "Rhannu'r Ardal",
    community_event: "Ychwanegu Digwyddiad",
    free_listing: "Am Ddim",
    basic_visibility: "Gwelededd sylfaenol",
    featured: "Dan Sylw",
    top_placement: "Safle blaen",
    featured_price: "Dan Sylw - £5/mis",
    feat_highlight: "Amlygwyd ar frig rhestrau",
    feat_badge: "Bathodyn arbennig ar y map",
    feat_priority: "Blaenoriaeth mewn chwiliadau",
    feat_analytics: "Mynediad i'r dangosfwrdd",
    feat_redirect: "Byddwch yn cael eich ailgyfeirio i greu cyfrif",
    event_title: "Teitl y Digwyddiad",
    description: "Disgrifiad",
    town_city: "Tref/Dinas",
    country: "Gwlad",
    event_type: "Math o Ddigwyddiad",
    contact_info: "Gwybodaeth Gyswllt",
    recurring_event: "Digwyddiad rheolaidd",
    schedule: "Amserlen",
    submit_event: "Cyflwyno",
    continue_payment: "Parhau i Dalu",
    submitting: "Yn cyflwyno...",
    meetup: "Cyfarfod",
    support_group: "Grŵp Cymorth",
    workshop: "Gweithdy",
    social_event: "Digwyddiad Cymdeithasol",
    my_pins: "Fy Mhinnau",
    move_edit: "Symud/Golygu",
    remove: "Dileu",
    people: "pobl",
    areas: "ardaloedd",
    calendar: "Calendr",
    event_calendar: "Calendr Digwyddiadau",
    no_events_date: "Dim digwyddiadau ar y dyddiad hwn",
    all_events: "Pob Digwyddiad",
    search: "Chwilio",
    close: "Cau",
    cancel: "Canslo",
    back_to_map: "Nôl i'r Map",
    people_in_area: "pobl yn yr ardal hon",
    community_breakdown: "Cyfansoddiad y Gymuned",
    language: "Iaith",
  },
};

const LANGUAGE_NAMES = {
  en: "English",
  zh: "中文",
  es: "Español",
  fr: "Français",
  sw: "Kiswahili",
  ar: "العربية",
  hi: "हिन्दी",
  vi: "Tiếng Việt",
  ru: "Русский",
  cy: "Cymraeg",
};

const LanguageContext = createContext();

function detectBrowserLanguage() {
  const browserLang = navigator.language?.split("-")[0] || "en";
  return translations[browserLang] ? browserLang : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("neuromap_lang");
    return saved && translations[saved] ? saved : detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem("neuromap_lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGE_NAMES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (!context) {
    return { lang: "en", setLang: () => {}, t: (k) => k, languages: LANGUAGE_NAMES };
  }
  return context;
}
